import { isPathAllowed } from '@/routes/protected/protectedRoute'
import { TourStep, WEB_TOUR_STEPS } from '@/designs/new/constants/webTourSteps'

/**
 * Checks if the user has permission to view a specific step based on its requiredPermission or route.
 */
export const isStepAllowed = (
  step: TourStep,
  allowedPaths: string[],
): boolean => {
  const permPath = step.requiredPermission || step.route
  if (!permPath) return true
  return isPathAllowed(permPath, allowedPaths)
}

/**
 * Finds the next authorized step index starting at `startIndex` in the given `direction`.
 */
export const findNextAuthorizedIndex = (
  startIndex: number,
  direction: 'forward' | 'backward',
  allowedPaths: string[],
): number => {
  let index = startIndex
  while (index >= 0 && index < WEB_TOUR_STEPS.length) {
    const step = WEB_TOUR_STEPS[index]
    if (isStepAllowed(step, allowedPaths)) {
      return index
    }
    if (process.env.NODE_ENV !== 'production') {
      console.warn(
        `[WebTour] Automatically skipping unauthorized step at index ${index}: "${step.title}" (route: ${step.route || 'none'})`,
      )
    }
    index = direction === 'forward' ? index + 1 : index - 1
  }
  return -1
}
